import React, { useEffect, useState } from 'react';
import { ViolationListItemStyle, ViolationStatusIconsWrapper } from './ViolationListView.styles';
import ViolationListIconComponent from './ViolationListIcon';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';
import { Violation } from 'src/types/ViewModel/Stowage/Violation/Violation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CargoOperationInfoMenu } from '../Stowage.styles';
import { useStowageStore } from 'src/context/StowageContext';
import ViolationStatusIcon from 'src/components/ui/status-icon/ViolationStatusIcon';
import CargoNumber from '../common/cargoNumber';
import { prettifyDateTimeHHmm } from 'odfjell-date-time-utils/dateTimeFormatter';

type Props = {
    violation: Violation;
};

const SCREEN_LARGE_WIDTH_THRESHOLD = 3000;

const ViolationListItemComponent: React.FC<Props> = (props) => {
    const [selectedViolationListItemClass, setSelectedViolationListItemClass] = useState<string>('');
    const { setSelectedViolations, selectedViolations, setSelectedTanks, selectedTanks, filteredViolations } = useStowageSelectionStore();
    const { setViolationListContextMenuState, violationListContextMenuState, tankPlanWindowResized } = useStowageStore();

    useEffect(() => {
        if (!selectedViolations) return;

        selectedViolations.includes(props.violation)
            ? setSelectedViolationListItemClass('selected-violation')
            : setSelectedViolationListItemClass('');
    }, [selectedViolations]);

    useEffect(() => {
        if (filteredViolations?.length > 0) {
            // Find all violations that are associated with any of the selected tanks
            const violationsForTanks = filteredViolations.filter((v) => selectedTanks.some((tank) => tank.tankId === v.tankId));

            setSelectedViolations(violationsForTanks);
        }
    }, [selectedTanks, filteredViolations]);

    const onClickViolation = (violation: Violation) => {
        setSelectedViolations([violation]);
        if (violation.tank) {
            setSelectedTanks([violation.tank]);
        }
    };
    const getViolationListMenu = () => {
        return (
            <ViolationStatusIconsWrapper>
                {getViolationMenu()}
                {getViolationStatusIcon()}
            </ViolationStatusIconsWrapper>
        );
    };

    const onOpenViolationMenu = (e) => {
        e.stopPropagation();

        const menuYPosition = calculateMenuYPosition(e);
        setViolationListContextMenuState({
            visible: !violationListContextMenuState.visible,
            tank: null,
            cargoContents: [],
            cargoOperationGuid: crypto.randomUUID(),
            berthCall: null,
            x: 35,
            y: menuYPosition,
            violations: [props.violation],
        });

        setSelectedViolations([props.violation]);
    };

    // Calculation methods
    const calculateMenuYPosition = (e: React.MouseEvent): number => {
        const panelHeight = 70;
        const pageHeaderOffset = 80;
        const windowHeight = window.innerHeight;

        let operationsMenuYpos = 0;
        if (window.innerWidth >= SCREEN_LARGE_WIDTH_THRESHOLD) {
            operationsMenuYpos = pageHeaderOffset;
            const operationsPanelYpos = pageHeaderOffset;
            const offsetItemClickedToPanelTop = e.clientY - operationsPanelYpos;
            operationsMenuYpos = offsetItemClickedToPanelTop;
        } else {
            let operationsPanelYpos = Number(tankPlanWindowResized.split('fr')[0]) * (windowHeight - pageHeaderOffset);
            operationsPanelYpos += pageHeaderOffset;
            const offsetItemClickedToPanelTop = e.clientY - operationsPanelYpos;
            operationsMenuYpos = operationsMenuYpos + offsetItemClickedToPanelTop;
        }

        if (e.clientY + panelHeight > windowHeight) {
            const adjustYPos = e.clientY + panelHeight > windowHeight ? e.clientY + panelHeight - windowHeight : 0;
            operationsMenuYpos = operationsMenuYpos - adjustYPos - 20;
        }

        return operationsMenuYpos;
    };

    const getViolationMenu = () => {
        return (
            <>
                <CargoOperationInfoMenu onClick={(e) => onOpenViolationMenu(e)} title="Open violation list menu">
                    <FontAwesomeIcon icon="ellipsis-h" />
                </CargoOperationInfoMenu>
            </>
        );
    };

    const getViolationStatusIcon = (): any => {
        return ViolationStatusIcon(props.violation.status);
    };

    return (
        <ViolationListItemStyle
            className={'violation-list-item' + ' ' + selectedViolationListItemClass}
            key={'violation-' + props.violation.violationGuid}
            onClick={() => onClickViolation(props.violation)}
        >
            <span className="col col-menu">{getViolationListMenu()}</span>
            <span className="col col-type">
                <ViolationListIconComponent violationType={props.violation.type} includeText={true} />
            </span>
            <span className="col col-cargo-nr">
                {props.violation.cargo && <CargoNumber includeColoredBackground={true} cargo={props.violation.cargo} />}
            </span>
            <span className="col col-description col-left" title={props.violation.description}>
                {props.violation.description}
            </span>
            <span className="col col-voyage">{props.violation.portCall?.voyageNumber}</span>
            <span className="col col-left">{props.violation.portCall?.portDisplayName}</span>
            <span className="col col-left">{props.violation.berthCall?.berthName}</span>
            <span className="col col-tank">{props.violation.tank?.tankName}</span>
            <span className="col col-tank">{props.violation.adjacentTank?.tankName}</span>
            <span className="col col-left col-accepted-by" title={props.violation.statusChangedBy}>
                {props.violation.statusChangedBy}
            </span>
            <span className="col col-date-time"> {prettifyDateTimeHHmm(props.violation.statusChangedUtc)}</span>
        </ViolationListItemStyle>
    );
};

export default ViolationListItemComponent;
